import { selectBetPositionClientError } from './selectBetPositionClientError';
import { IAppState } from '../../redux';

export function selectIsBetPositionVisible(state: IAppState): boolean {
  const clientError = selectBetPositionClientError(state);

  return !clientError;
}
